module.exports = __webpack_public_path__ + "img/pos-wristband.0f58daba.png";